import { useContext, useState } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import Image from 'next/image';
import { Trans, useTranslation } from 'next-i18next';
import { Button, ThemeContext } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
import Link from '@/components/Link';
import Video from '@/components/Video';
import { analytics } from '@/helpers/analytics';
// import { RequestDemoForm, RequestDemoResult } from './elements';
// import { useRequestDemo } from './useRequestDemo';
import { RequestDemoModal2Form } from '../RequestDemoModal2';
import { useRequestCall } from '../RequestCall';

import styles from './request-demo.module.css';

const SuccessMessage = () => {
  return (
    <div className={styles.result}>
      Вы записались на демонстрацию сервиса, в ближайшее время мы свяжемся с вами для подтверждения.
    </div>
  );
};

const RequestDemo = () => {
  const { t } = useTranslation();
  const { lang, viewport } = useContext(ThemeContext);
  const isPhone = ['phone', 'tabletS', 'tablet'].includes(viewport);
  const [isShowVideo, setShowVideo] = useState(false);

  // const {
  //   onSubmit,
  //   saveResult,
  //   isSuccess,
  //   isError
  // } = useRequestDemo({ lang });

  // const handleSubmit = (values) => {
  //   onSubmit(values).then(success => {
  //     if (success) {
  //       window.scrollTo({ top: 0, left: 0 });
  //       analytics.sendRequestFullForm();
  //     }
  //   });
  // };

  const { onSubmit, isSuccess, isError, isLoading } = useRequestCall({ lang });

  const handleSubmit = (values) => {
    onSubmit(values).then(success => {
      if (success) {
        analytics.sendRequestForm();
      }
    });
  };

  return (
    <PageBlock className={styles.root} id="request_demo" variant="white">
      <div className={styles.container}>
        <div className={styles.form}>
          <h1 className={styles.title}>
            Пробуйте бесплатно 7 дней
          </h1>
          <p className={styles.subtitle}>
            Заполните поля и вы получите бесплатный доступ.
            Эксперт сервиса презентует возможности сервиса и перенесет до 5-ти документов бесплатно.
          </p>
          {/* {(isSuccess || isError) && (
            <RequestDemoResult isSuccess={isSuccess} isError={isError} />
          )}
          {!(isSuccess || isError) && (
            <div className={styles.form}>
              <RequestDemoForm onSubmit={handleSubmit} />
            </div>
          )} */}

          {!isPhone && (
            isSuccess ? (
              <SuccessMessage />
            ) : (
              <RequestDemoModal2Form
                onSubmit={handleSubmit}
                isSendSuccess={isSuccess}
                isSendError={isError}
                isSendLoading={isLoading}
                buttonText={t('activate_demo_access')}
                noticeText={
                  <Trans
                    i18nKey="user_agreement_form_notice"
                    components={{
                      privacy: <Link href="/privacy" target="_blank" />,
                      license: <Link href="/license" target="_blank" />,
                      button: t('activate_demo_access'),
                    }}
                  />
                }
              />
            )
          )}
        </div>
        <div className={styles.content}>
          <div className={styles.videoContainer}>
            {isShowVideo ? (
              <Video className={styles.video} src="https://static.forma.today/videos/common.mp4" autoPlay />
            ) : (
              <Image className={styles.video} src="/images/video-nikita.webp" width={533} height={300} alt="" />
            )}
            {!isShowVideo && (
              <Button
                viewStyle="secondary"
                className={classNames(styles.button, styles.secondary, styles.playButton)}
                onClick={() => setShowVideo(true)}
                icon={<ReactSVG src="/icons/play-2.svg" className={styles.playIcon} />}
              >
                {t('watch_video')}
              </Button>
            )}
          </div>

          <div className={styles.contentTitle}>
            Оцените как это будет происходить:
          </div>
          <ul className={styles.contentList}>
            <li className={styles.contentListItem}>
              Эксперты сервиса свяжутся с вами, чтобы определить бизнес-запрос, с учётом ваших целей и задач
            </li>
            <li className={styles.contentListItem}>
              Покажем возможности онлайн-конструктора документов за 15 минут
            </li>
            <li className={styles.contentListItem}>
              Предоставим пробный доступ на 7 дней, перенесем и настроим до 5-ти документов, а также ответим на любые вопросы
            </li>
          </ul>
        </div>

        {isPhone && (
          isSuccess ? (
            <SuccessMessage />
          ) : (
            <RequestDemoModal2Form
              onSubmit={handleSubmit}
              isSendSuccess={isSuccess}
              isSendError={isError}
              buttonText={t('activate_demo_access')}
              noticeText={
                <Trans
                  i18nKey="user_agreement_form_notice"
                  components={{
                    privacy: <Link href="/privacy" target="_blank" />,
                    license: <Link href="/license" target="_blank" />,
                    button: t('activate_demo_access'),
                  }}
                />
              }
            />
          )
        )}
      </div>
    </PageBlock>
  );
};

export default RequestDemo;
